/**
 * The binding map this tab plays on.
 *
 * One record, written by the settings knob and read per tick by every control map, which is what
 * lets a rebind change the very next frame with a game running behind the screen. The store holds
 * whatever the pure operations in [bindingOps](./bindingOps.ts) produced, so the invariant that no
 * code means two things is theirs and nothing here re-checks it.
 */

import { DEFAULT_BINDINGS } from '@/core/input/bindings/defaultBindings';
import type { BindableActionId, BindingMap } from '@/core/input/bindings/bindingContract';

let map: BindingMap = DEFAULT_BINDINGS;

export function bindingMap(): BindingMap {
  return map;
}

export function setBindingMap(next: BindingMap): void {
  map = next;
}

/** What a control map asks per tick: the codes that mean this action right now. */
export function boundCodes(action: BindableActionId): readonly string[] {
  return map[action];
}
